import React from 'react';
import classNames from 'classnames';
import styles from './Button.css';

/**
 *
 * @param {Object} options - Configuration options for the button.
 *
 * `onClick` - What the button does on click.
 *
 * `size` - Can be one of the three, `normal`, `small` and `large`. Default value is `normal`
 *
 * `children` - What the component needs to render.
 *
 * `type` - Can be `primary`, `secondary` or `tertiary`. Default value is `primary`.
 *
 * `invert` - Boolean - Whether to exchange the background and color of the button.
 */
export default function Button({
  onClick,
  size = 'normal',
  children,
  type = 'primary',
  invert = false,
  disabled = false,
}) {
  return (
    <button
      type='button'
      onClick={!disabled ? onClick : () => {}}
      className={classNames(styles.button, styles[size], styles[type], {
        [styles.invert]: invert,
        [styles.disabled]: disabled,
      })}
    >
      {children}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js